import { useEffect } from 'react';
import { initializePosthog } from '../../utils';

interface UsePosthogIntegrationWithConfigProps {
  enable?: boolean;
}

const usePosthogIntegrationWithConfig = ({
  enable = true,
}: UsePosthogIntegrationWithConfigProps = {}) => {
  const posthogToken = process.env.REACT_APP_POSTHOG_TOKEN;

  useEffect(() => {
    if (!enable || !posthogToken) {
      return;
    }

    initializePosthog(posthogToken);
  }, [enable, posthogToken]);

  return null;
};

export default usePosthogIntegrationWithConfig;
